module.exports = __webpack_public_path__ + "img/49.2.TN.a1b568d7.png";